import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {View, StyleSheet} from 'react-native';
import {Text} from 'trpc-react-native-ui';

import I18n from '../../../../lib/i18n';

var styles = StyleSheet.create({
  legend: {
    top: 10,
    marginBottom: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  legendCurrent: {
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
  },
  legendMax: {
    fontSize: 12,
    fontWeight: '300',
    textAlign: 'center',
  },
});

class BaseDoughnutLegend extends Component {
  getMainLegend = () => {
    let mainLegend;
    const {max, current, legendText} = this.props;
    if (
      max &&
      typeof max === 'string' &&
      (max.toLowerCase() === I18n.t('VALUE_UNL').toLowerCase() || max === 'UNL')
    ) {
      mainLegend = I18n.t('unlimitedValueWithCaps');
    } else if (current === I18n.t('nothing')) {
      mainLegend = current;
    } else if (current) {
      mainLegend = I18n.t('left', {value: current});
    } else if (legendText) {
      mainLegend = legendText;
    } else {
      mainLegend = '';
    }
    return mainLegend;
  };

  displayMaxLabel = () => {
    const {current, hideMaxValue, max} = this.props;
    if (
      max &&
      !hideMaxValue &&
      current !== I18n.t('nothing') &&
      (typeof max !== 'string' ||
        (max.toLowerCase() !== I18n.t('VALUE_UNL').toLowerCase() &&
          max !== 'UNL'))
    ) {
      return (
        <Text style={styles.legendMax}>
          {I18n.t('outOf')} {max}
        </Text>
      );
    }
  };

  render() {
    let {iconColor, textColor, color, isActive} = this.props;

    if (!iconColor) {
      iconColor = color;
      textColor = color;
    }

    return (
      <View style={styles.legend}>
        <Text
          style={[styles.legendCurrent, isActive ? {color: textColor} : {}]}>
          {this.getMainLegend()}
        </Text>
        {this.displayMaxLabel()}
      </View>
    );
  }
}

BaseDoughnutLegend.propTypes = {
  current: PropTypes.any,
  max: PropTypes.any,
  isActive: PropTypes.bool,
  label: PropTypes.string,
  color: PropTypes.string,
  iconColor: PropTypes.string,
  textColor: PropTypes.string,
  legendText: PropTypes.string,
};

export default BaseDoughnutLegend;
